import { resolveSafeInternalPath } from "./intendedUrl";

export async function continueToReturnUrl({ queryClient, history, returnUrl }) {
	const destination = resolveSafeInternalPath(returnUrl);
	if (!destination) {
		return false;
	}

	await queryClient.refetchQueries("guards");
	const guards = queryClient.getQueryData(["guards"]);

	if (!guards || guards.blocker || guards.canAccessPortal === false) {
		return false;
	}

	history.push(destination);
	return true;
}
